import React from 'react';

function BannerEdge(props) {
  return (
    <svg
      fill="currentColor"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      clipRule="evenodd"
      viewBox="0 0 49 50"
      {...props}
    >
      <path
        fillRule="nonzero"
        d="M48.544 0c-1.34-.033-17.08.469-20.194.335-.301 0-4.622-.034-5.191 0-4.387.1-15.506-.67-19.658 0-.704.1-1.407.368-2.043.703C1.02 1.273.654 1.641.15 2.11a.41.41 0 000 .636C1.29 3.784 2.563 5.09 3.668 5.894c5.158 3.684 16.71 8.406 21.97 11.956 2.51 1.674 4.219 4.086 6.362 6.028-.134 1.172-.837 1.842-1.607 2.378-2.11 1.54-4.22 3.114-6.43 4.487-3.65 2.278-7.368 4.388-11.052 6.598a3.19 3.19 0 01-.703.301c-4.69 1.44-8.205 4.454-11.12 8.272-.2.235-.802.77-1.003.971 0 .436-.335.67.335 1.005 1.172.837 2.51 1.139 3.884 1.273 1.54.134 3.115.234 4.655.268 7.234.067 14.5.067 21.735.2 5.96.101 11.889.235 17.85.369V0z"
      />
    </svg>
  );
}

export { BannerEdge };
